export default __webpack_public_path__ + "static/media/level-2.090ca1c4.png";